import { CoreIcon } from '../core-icon';
import chevronRightSVG from '../../assets/icons/chevron-right.svg';
import type { IconProps } from '../core-icon';

export const ChevronRightIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronRightSVG} {...props} />;
};
